import { DispatcherEvent } from '@carvana/merch-native';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import ModalContext from '~/contexts/ModalContext';
import sendMessageToNative from './sendMessageToNative';

export default function useFullscreenDispatcher() {
  const { isAnyModalOpen, isGeolocationModalOpen, isSoftPullModalOpen } =
    useContext(ModalContext);

  const isNativeModalOpen = isGeolocationModalOpen || isSoftPullModalOpen;
  const isWebModalOpen = isAnyModalOpen && !isNativeModalOpen;

  useSubsequentEffect(() => {
    sendMessageToNative(
      isWebModalOpen
        ? DispatcherEvent.EnterFullscreen
        : DispatcherEvent.LeaveFullscreen,
      {}
    );
  }, [isWebModalOpen]);
}
